module.exports = __webpack_public_path__ + "static/img/nine6.6f343ea7.jpg";